import {useState} from 'react';

import {createFakeFolder} from 'app/demo/demo_fixtures/folders';
import {
  generateBasicTeamFromTeam,
  getTeamByURL,
} from 'app/demo/demo_fixtures/teams';

import {folderListSource, teamListSource} from '../../demo_fixtures';
import {EventEmitter} from '../../EventEmmiter';
import {createResponseList, useData, waitAndReturn} from '../../utils';

export const FOLDER_TAGS = {
  TAGS: 'folder',
  HASHID: 'folderhashid',
};

export const useFolders = ({parent}) => {
  const {data, isFetching} = useData(
    folderListSource,
    'foldersUpdate',
    eventEmitter
  );

  const basic_team = {};
  teamListSource.results.map((team) => {
    basic_team[team.id] = generateBasicTeamFromTeam(team);
  });

  const folders = data.results
    .filter((f) => f.parent === (parent || null))
    .map((folder) => {
      return {
        ...folder,
        teams: folder.teams.map((team) => basic_team[team.id]),
      };
    });

  return {
    isFetching,
    data: createResponseList(folders),
    refetch: () => {
      eventEmitter.emit('foldersUpdate', folderListSource);
    },
  };
};

export const useUpdateFolder = () => ({});

export const useAddTeamsToFolder = () => ({});

export const useRemoveTeamsFromFolder = () => ({});

export const useDeleteFolder = () => ({});

export const useMoveFolder = () => ({});

export const useFolderByHashid = () => ({});

export const useCreateFolder = () => {
  const [responseState, setResponseState] = useState({
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  });

  const createFolder = ({name, teamURLs, parent}) => {
    setResponseState({
      isLoading: true,
      isSuccess: false,
      isError: false,
      error: null,
    });

    return waitAndReturn(() => {
      setResponseState({
        isLoading: false,
        isSuccess: true,
        isError: false,
        error: null,
      });
      const parent_hashid = parent == null ? null : parent.hashid;
      const folder = createFakeFolder(
        name,
        name.replace(' ', '-'),
        teamURLs.map((url) => getTeamByURL(url)),
        parent_hashid
      );
      folderListSource.results.push(folder);
      folderListSource.count = folderListSource.results.length;
      eventEmitter.emit('foldersUpdate', folderListSource);
    });
  };
  return [createFolder, responseState];
};

export const eventEmitter = new EventEmitter();
